import { quickWebLogger } from '@quickweb/logger';
import { extractError } from 'src/app/utils/error-utils';

export class CxOneUtils {
  public static CreateDictionaryFromPopUrl(popUrl: any): any {
    try {
      if (typeof popUrl !== 'string' || popUrl.trim() === '') {
        return {};
      }

      const dictionary: any = {};

      popUrl = popUrl.replaceAll("'", '"');

      const screenPopUrl = popUrl.split('|');
      screenPopUrl.forEach((par: any) => {
        const idx = par.indexOf(':');
        if (idx > 0) {
          const key = par.substring(0, idx).trim();
          const value = par.substring(idx + 1).trim();
          dictionary[key] = value;
        }
      });
      return dictionary;
    } catch (error) {
      quickWebLogger.logger.error(
        'Erro ao criar dicionário a partir do popUrl',
        {
          exception: extractError(error),
          popUrl,
        },
      );
      return {};
    }
  }

  public static parseSingleQuotedJson<T = Record<string, unknown>>(
    input: string,
  ): T {
    if (typeof input !== 'string') {
      throw new TypeError('Esperado uma string como entrada.');
    }

    let s = input.trim();
    if (
      (s.startsWith('"') && s.endsWith('"')) ||
      (s.startsWith("'") && s.endsWith("'"))
    ) {
      s = s.slice(1, -1);
    }

    const normalized = s.replace(/'/g, '"');

    try {
      return JSON.parse(normalized) as T;
    } catch (err) {
      // Ajuda no diagnóstico
      const e = err as Error;
      throw new Error(
        `Falha ao fazer parse do JSON normalizado: ${e.message}\nConteúdo: ${normalized}`,
      );
    }
  }

  public static Delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public static ExtractDataObjectFromPopUrl(
    digitalEvent: any,
  ): Record<string, string> {
    try {
      //console.log('Console log recebido: ', JSON.stringify(digitalEvent.case));
      const result: Record<string, string> = {};

      if (digitalEvent?.channelId) {
        result['PONTODECONTATO'] = digitalEvent.channelId;
      }

      if (digitalEvent?.authorEndUserIdentity) {
        result['INTERACTIONTYPE'] =
          digitalEvent.authorEndUserIdentity.externalPlatformId.toUpperCase();
        result['USERID'] =
          digitalEvent.authorEndUserIdentity.idOnExternalPlatform;
      }

      let masterId: string = digitalEvent.id;
      let channelId: string = digitalEvent.channelId;

      if (Array.isArray(digitalEvent?.customFields)) {
        digitalEvent.customFields.forEach((f: any) => {
          if (f?.label) {
            const key = f.label.toUpperCase();

            if (key === 'HISTORICO') {
              result[key] =
                `${f.value}&interaction_id=${masterId}_${channelId}`;
            } else {
              result[key] = f.value;
            }
          }
        });
      }

      //console.log('Console log return: ', JSON.stringify(result));
      return result;
    } catch (error) {
      //console.log('Erro: ', error);
      return {};
    }
  }
}
